export enum Visibility {
    Unrestricted = 0,
    Private = 1,
    SelectedContacts = 2,
}